import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { container } from '@infrastructure/container';
import { CompanySettings } from '@domain/account/models/Company';

export const COMPANY_SETTINGS_QUERY_KEY = ['company-settings'] as const;

export const useCompanySettings = () => {
  const queryClient = useQueryClient();

  const { data: settings, isLoading, error } = useQuery({
    queryKey: COMPANY_SETTINGS_QUERY_KEY,
    queryFn: async () => {
      const result = await container.companyRepository.getSettings();
      if (result.status === 'error') throw new Error(result.error.message);
      return result.data;
    },
  });

  const { mutateAsync: updateSettings, isPending: isUpdating } = useMutation({
    mutationFn: async (partial: Partial<CompanySettings>) => {
      const result = await container.companyRepository.updateSettings(partial);
      if (result.status === 'error') throw new Error(result.error.message);
      return result.data;
    },
    onSuccess: (data) => {
      queryClient.setQueryData(COMPANY_SETTINGS_QUERY_KEY, data);
    },
  });

  return {
    settings,
    isLoading,
    error,
    updateSettings,
    isUpdating,
  };
};
